export const isAsyncIterable = (v) => {
    if (typeof v !== `object`)
        return false;
    if (v === null)
        return false;
    return Symbol.asyncIterator in v;
};
export const isIterable = (v) => {
    if (typeof v !== `object`)
        return false;
    if (v === null)
        return false;
    return Symbol.iterator in v;
};
